import React from 'react';
import PropTypes from 'prop-types';
import { morph } from '../common';
import './ListStatistics.css';

const ListStatistics = ({
  total, accept, visited, result
}) => (
  <div className="ListStatistics_Wrapper">
    <span className="ListStatistics_Find">Найдено: </span>
    <span className="ListStatistics_Total"> {morph(total, 'запись', 'записи', 'записей')} </span>|
    <span className="ListStatistics_Accept"> {morph(accept, 'подтвержденная', 'подтвержденные', 'подтвержденных')} </span>|
    <span className="ListStatistics_Visited"> {morph(visited, 'приход', 'прихода', 'приходов')} </span>|
    <span className="ListStatistics_Result"> {morph(result, 'договор', 'договора', 'договоров')}</span>
  </div>
);

ListStatistics.propTypes = {
  total: PropTypes.number.isRequired,
  accept: PropTypes.number.isRequired,
  visited: PropTypes.number.isRequired,
  result: PropTypes.number.isRequired
};

export default ListStatistics;



// WEBPACK FOOTER //
// ./src/components/ListStatistics.js